import React, { FC, useEffect } from 'react';
import AccordionWidgetIcon from 'app/modules/posts/components/accordionWidget/AccordionWidgetIcon';
import { usePostComposer } from 'app/modules/posts/modules/post/components/composer/PostComposerProvider';
import { TYPE } from '@kontentino/kontentino-constants/Pages';
import PostComposerPublishingMethodInstagram from 'app/modules/posts/modules/post/components/composer/postComposerPublishingMethod/PostComposerPublishingMethodInstagram';
import AccordionWidget from 'app/modules/posts/components/AccordionWidget';
import AccordionWidgetTitle from 'app/modules/posts/components/accordionWidget/AccordionWidgetTitle';
import { Chip } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import PostsConfig from 'app/config/posts';

type Props = {
  accordionProps?: Omit<
    React.ComponentProps<typeof AccordionWidget>,
    'title' | 'titleSuffix' | 'icon'
  >;
};

const PostComposerPublishingMethod: FC<Props> = ({ accordionProps }) => {
  const { form, setForm } = usePostComposer();
  const { t } = useTranslation();

  const isDirectPublishAvailable =
    form.attachments.cards.length <=
    PostsConfig.INSTAGRAM_MAXIMUM_ATTACHMENTS_API_PUBLISH;

  useEffect(() => {
    if (form.page.type === TYPE.INSTAGRAM) {
      if (!isDirectPublishAvailable) {
        setForm((prev) => ({
          attachments: {
            ...prev.attachments,
            publishingMethod: 'mobileApp',
          },
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.attachments.cards.length, form.page.type]);

  if (form.page.type === TYPE.INSTAGRAM) {
    return (
      <AccordionWidget
        title={<AccordionWidgetTitle variant="publishingMethod" />}
        titleSuffix={(isOpen) =>
          !isOpen &&
          form.attachments.publishingMethod && (
            <Chip variant="darkGrey">
              {t(
                `instagramPublishingMethods.${
                  form.attachments.publishingMethod === 'mobileApp'
                    ? 'manual'
                    : 'direct'
                }Publishing.label`,
              )}
            </Chip>
          )
        }
        icon={<AccordionWidgetIcon variant="publishingMethod" />}
        data-name="posts-composer_publishing-method"
        {...accordionProps}
      >
        <PostComposerPublishingMethodInstagram
          disabledMethods={!isDirectPublishAvailable ? ['direct'] : []}
          value={form.attachments.publishingMethod}
          pseudoType={form.pseudoType}
          onChange={(publishingMethod) =>
            setForm((prev) => ({
              attachments: {
                ...prev.attachments,
                publishingMethod,
              },
            }))
          }
        />
      </AccordionWidget>
    );
  }

  return null;
};

export default PostComposerPublishingMethod;
